import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Button from "components/CustomButtons/Button.jsx";

import impersonateUserStyle from "assets/jss/material-dashboard-pro-react/views/impersonateUserStyle.jsx";
import Assignment from "@material-ui/icons/Assignment";
import UserSearch from "./UserSearch";
import connection from "../connection";
import general from "../general";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUser} from "@fortawesome/free-solid-svg-icons";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";

class ImpersonateUser extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      original_user: window.App.state.user.is_impersonating,
      show_card: false
    };

    this.impersonate = this.impersonate.bind(this);
    this.stopImpersonating = this.stopImpersonating.bind(this);
  }

  stopImpersonating() {
    const {classes} = this.props;

    return (<Card className={classes.impersonateFloatingCard}>
      <CardHeader color="primary" icon>
        <CardIcon color="primary">
          <Assignment/>
        </CardIcon>
        <h4 className={classes.cardIconTitle}>Personificar Utilizador</h4>
      </CardHeader>
      <CardBody>
        <Button
          className={classes.button + " " + classes.primary + " " + classes.adicionarFormandoButton}
          onClick={() => {
            connection.get("utilizador/stop_impersonation", null, (data) => {
              if (data.success) {
                general.success("Voltou à sua conta original.", "Sucesso");
                window.App.setState({
                  user: {
                    name: data.original_user.user,
                    id: data.original_user.user_id,
                    tipo: data.original_user.user_type
                  }
                });
                this.setState({
                  original_user: null
                });
                // Voltar para página inicial
                window.location.href = "/dashboard";
              } else {
                general.error("Por favor tente novamente.", "Erro");
              }
            });
          }}
        >Voltar ao Utilizador Original</Button>
      </CardBody>
    </Card>);
  }

  impersonate() {
    const {classes} = this.props;

    function submit() {
      to_impersonate &&
      connection.get("utilizador/impersonate", {user_id: to_impersonate.id}, (data) => {
        if (data.success) {
          window.location.reload();
        } else {
          general.error("Por favor tente novamente.", "Erro");
        }
      });
    }

    let to_impersonate = null;
    return (<Card className={classes.impersonateFloatingCard}>
      <CardHeader color="primary" icon>
        <CardIcon color="primary">
          <Assignment/>
        </CardIcon>
        <h4 className={classes.cardIconTitle}>Personificar Utilizador</h4>
      </CardHeader>
      <CardBody>
        <form autoComplete="off" className={classes.cardForm} onSubmit={submit}>
          <UserSearch
            labelText="NIN ou Email do Utilizador"
            id="userIdImpersonate"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "text",
              name: "user_id"
            }}
            onFoundUser={(user) => {
              to_impersonate = user;
            }}
          />
        </form>
        <Button
          className={classes.button + " " + classes.primary + " " + classes.adicionarFormandoButton}
          onClick={submit}
        >Personificar</Button>
      </CardBody>
    </Card>);
  }

  render() {
    const {classes} = this.props;
    return (window.App.state.user.can_impersonate_user || window.App.state.user.is_impersonating) ? (<div className={classes.floatingImpersonate}>
      {this.state.show_card &&
        (this.state.original_user ? this.stopImpersonating() : this.impersonate())
      }
      <Tooltip
        title="Personificar Utilizador"
        placement="left"
        classes={{tooltip: classes.tooltip}}
      >
        <Button
          justIcon
          round
          onClick={() => {
            this.setState({
              show_card: !this.state.show_card
            })
          }}
          color="primary"
          className={classes.impersonateFloatingButton}
        >
          <FontAwesomeIcon icon={faUser}/>
        </Button>
      </Tooltip>
    </div>) : null;
  }
}

export default withStyles(impersonateUserStyle)(ImpersonateUser);
